import React, { createContext, useContext, useState, useEffect } from 'react';

export type Language = 'ru' | 'kz';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

const translations = {
  ru: {
    // Header
    'nav.home': 'Главная',
    'nav.about': 'О компании',
    'nav.catalog': 'Посмотреть прайс',
    'nav.services': 'Услуги',
    'nav.contacts': 'Контакты',
    'nav.cart': 'Корзина',
    'nav.orderCall': 'Заказать звонок',
    'nav.orderCallShort': 'Звонок',
    
    // Hero Section
    'hero.company': 'ТОО «KazPolimerPlast»',
    'hero.tagline': 'трубы полиэтиленовые с 2010 года',
    'hero.description': 'Производственная мощность 6000 тонн трубной продукции в год. Диаметр от 20 до 1200 мм. 4 экструзионные линии с современным оборудованием.',
    'hero.catalog': 'Смотреть прайс',
    'hero.catalogShort': 'Посмотреть прайс',
    'hero.calculate': 'Рассчитать стоимость',
    'hero.calculateShort': 'Расчет',
    'hero.fastDelivery': 'Быстрая доставка',
    'hero.qualityGuarantee': 'Гарантия качества',
    'hero.certificates': 'Сертификаты',
    'hero.experience': 'Опыт 15+ лет',
    
    // Features Section
    'features.badge': 'Преимущества работы с нами',
    'features.title': 'Почему выбирают',
    'features.subtitle': 'Более 15 лет опыта в производстве качественных полиэтиленовых труб. Надежный партнер для ваших проектов.',
    'features.tech.title': 'Современные технологии',
    'features.tech.desc': '4 экструзионные линии с современным оборудованием от ведущих мировых производителей',
    'features.capacity.title': 'Производственная мощность',
    'features.capacity.desc': 'Годовая производственная мощность 6000 тонн трубной продукции. Диаметр от 20 до 1200 мм',
    'features.team.title': 'Высококвалифицированный персонал',
    'features.team.desc': 'Высококвалифицированный инженерно-технический персонал с многолетним опытом',
    'features.management.title': 'Системы менеджмента',
    'features.management.desc': 'Сертификаты систем менеджмента качества, экологического менеджмента и профессиональной безопасности',
    'features.founded': 'год основания',
    'features.tonsYear': 'тонн в год',
    'features.lines': 'экструзионные линии',
    'features.maxDiameter': 'макс. диаметр мм',
    
    // Products Section
    'products.badge': 'Наша продукция',
    'products.title': 'Прайс-листы',
    'products.subtitle': 'Широкий ассортимент полиэтиленовых труб и комплектующих для любых инженерных задач',
    'products.water.title': 'Трубы полиэтиленовые для водоснабжения',
    'products.water.desc': 'Диаметр 20-1200 мм',
    'products.sewer.title': 'Трубы полиэтиленовые для канализации',
    'products.sewer.desc': 'Диаметр 20-1200 мм',
    'products.gas.title': 'Трубы полиэтиленовые для газоснабжения',
    'products.gas.desc': 'Диаметр 20-1200 мм',
    'products.coextruded.title': 'Трубы с соэкструзионными слоями',
    'products.coextruded.desc': 'Многослойные трубы',
    'products.fittings.title': 'Фитинги и отводы',
    'products.fittings.desc': 'Полный ассортимент',
    'products.more': 'Подробнее',
    'products.fullCatalog': 'Все прайс-листы',
    'products.consultation': 'Получить консультацию',
    'products.notFound': 'Не нашли нужную продукцию? Свяжитесь с нами для консультации',
    
    // About Page
    'about.title': 'О компании ТОО «KazPolimerPlast»',
    'about.subtitle': 'Компания специализируется на выпуске труб полиэтиленовых для систем водоснабжения, канализации, газоснабжения',
    'about.history': 'История компании',
    'about.founded': 'ТОО «KazPolimerPlast» была основана в феврале 2010 года в городе Уральск, Республика Казахстан, с целью производства высококачественных полиэтиленовых труб.',
    'about.specialization': 'Компания специализируется на выпуске труб полиэтиленовых для систем водоснабжения, канализации, газоснабжения, а также труб с соэкструзионными слоями и фитингов.',
    'about.production': 'Производство осуществляется на современном оборудовании от ведущих мировых производителей с применением передовых технологий.',
    'about.capacity': 'Производственные мощности',
    'about.team': 'Высококвалифицированный персонал',
    'about.teamDesc': 'Наша команда состоит из высококвалифицированного инженерно-технических работников с многолетним опытом работы в области производства полиэтиленовых труб. Современные технологии и постоянное совершенствование производственных процессов позволяют нам выпускать продукцию высочайшего качества.',
    
    // Header top bar
    'header.phone': 'Телефон',
    'header.address': 'г. Уральск, ул. Полевая 1Д, нежилое помещение 1',
    'header.addressShort': 'г. Уральск',
    'header.workHours': 'Пн-Пт: 9:00-18:00',
    'header.openMenu': 'Открыть меню',
    'header.viewPrice': 'Посмотреть прайс',
    'nav.certificates': 'Сертификаты',

    // Quick calculator
    'calc.title': 'Быстрый расчет',
    'calc.pipeType': 'Тип трубы',
    'calc.selectType': 'Выберите тип',
    'calc.water': 'Водопроводная',
    'calc.sewer': 'Канализационная',
    'calc.gas': 'Газопроводная',
    'calc.telecom': 'Для телекоммуникаций',
    'calc.diameter': 'Диаметр (мм)',
    'calc.sdr': 'SDR',
    'calc.selectSdr': 'Выберите SDR',
    'calc.length': 'Длина (м)',
    'calc.delivery': 'Поставка',
    'calc.selectDelivery': 'Выберите тип',
    'calc.coils': 'В бухтах',
    'calc.segments': 'В отрезках',
    'calc.city': 'Город доставки',
    'calc.selectCity': 'Выберите город',
    'calc.submit': 'Отправить заявку',
    'calc.discount': 'Получите персональную скидку при заказе от 1000 м',
    'calc.cityAlert': 'Пожалуйста, выберите город доставки',
    'calc.cityTitle': 'Выберите город доставки',
    'calc.citySearch': 'Поиск города...',
    'calc.cityNotFound': 'Город не найден',
    'calc.popularCities': 'Популярные города:',
    'calc.discountBadge': 'Скидка до 25% на оптовые заказы',
    'calc.submitSuccess': 'Заявка отправлена! Мы свяжемся с вами в ближайшее время.',

    // Calculator section
    'calculator.title': 'Калькулятор стоимости',
    'calculator.subtitle': 'Рассчитайте стоимость вашего проекта за 30 секунд',
    'calculator.feature1': 'Мгновенный расчет стоимости',
    'calculator.feature2': 'Учет всех параметров продукции',
    'calculator.feature3': 'Актуальные цены и скидки',
    'calculator.feature4': 'Отправка расчета на email',
    'calculator.quantity': 'Количество',
    'calculator.submit': 'Получить расчет',

    // WhatsApp widget
    'whatsapp.greeting': 'Здравствуйте! Чем мы можем вам помочь?',
    'whatsapp.message': 'Здравствуйте! Хотел бы узнать подробнее о вашей продукции.',
    'whatsapp.formTitle': 'Написать в WhatsApp',
    'whatsapp.formName': 'Ваше имя',
    'whatsapp.formPhone': 'Телефон',
    'whatsapp.formMessage': 'Сообщение',
    'whatsapp.formSubmit': 'Отправить в WhatsApp',

    // Common
    'common.loading': 'Загрузка...',
    'common.error': 'Ошибка',
    'common.save': 'Сохранить',
    'common.cancel': 'Отмена',
    'common.close': 'Закрыть',
    'common.submit': 'Отправить',
    'common.edit': 'Редактировать',
    'common.delete': 'Удалить',
    'common.confirm': 'Подтвердить',
    'common.yes': 'Да',
    'common.no': 'Нет',
  },
  kz: {
    // Header
    'nav.home': 'Басты бет',
    'nav.about': 'Компания туралы',
    'nav.catalog': 'Прайс-листтерді көру',
    'nav.services': 'Қызметтер',
    'nav.contacts': 'Байланыс',
    'nav.cart': 'Себет',
    'nav.orderCall': 'Қоңырау шалуды тапсырыс беру',
    'nav.orderCallShort': 'Қоңырау',
    
    // Hero Section
    'hero.company': '«KazPolimerPlast» ЖШС',
    'hero.tagline': '2010 жылдан бері полиэтилен құбырлары',
    'hero.description': 'Жылдық өндіріс қуаты 6000 тонна құбыр өнімі. Диаметрі 20-дан 1200 мм-ге дейін. Заманауи жабдықтары бар 4 экструзиялық желі.',
    'hero.catalog': 'Прайс-листтерді көру',
    'hero.catalogShort': 'Прайс-листтер',
    'hero.calculate': 'Құнын есептеу',
    'hero.calculateShort': 'Есептеу',
    'hero.fastDelivery': 'Жылдам жеткізу',
    'hero.qualityGuarantee': 'Сапа кепілдігі',
    'hero.certificates': 'Сертификаттар',
    'hero.experience': '10+ жыл тәжірибе',
    
    // Features Section
    'features.badge': 'Бізбен жұмыс істеудің артықшылықтары',
    'features.title': 'Неліктен таңдайды',
    'features.subtitle': '10 жылдан астам сапалы полиэтилен құбырларын өндіру тәжірибесі. Сіздің жобаларыңыз үшін сенімді серіктес.',
    'features.tech.title': 'Заманауи технологиялар',
    'features.tech.desc': 'Әлемдегі жетекші өндірушілердің заманауи жабдықтарымен 4 экструзиялық желі',
    'features.capacity.title': 'Өндірістік қуат',
    'features.capacity.desc': 'Жылдық өндіріс қуаты 6000 тонна құбыр өнімі. Диаметрі 20-дан 1200 мм-ге дейін',
    'features.team.title': 'Жоғары білікті құрам',
    'features.team.desc': 'Көп жылдық тәжірибесі бар жоғары білікті инженерлік-техникалық құрам',
    'features.management.title': 'Менеджмент жүйелері',
    'features.management.desc': 'Сапа менеджменті, экологиялық менеджмент және кәсіби қауіпсіздік жүйелерінің сертификаттары',
    'features.founded': 'құрылған жыл',
    'features.tonsYear': 'тонна жылына',
    'features.lines': 'экструзиялық желілер',
    'features.maxDiameter': 'макс. диаметр мм',
    
    // Products Section
    'products.badge': 'Біздің өнімдер',
    'products.title': 'Прайс-листтер',
    'products.subtitle': 'Кез келген инженерлік міндеттер үшін полиэтилен құбырлары мен жабдықтардың кең ассортименті',
    'products.water.title': 'Су жеткізу үшін полиэтилен құбырлары',
    'products.water.desc': 'Диаметрі 20-1200 мм',
    'products.sewer.title': 'Канализация үшін полиэтилен құбырлары',
    'products.sewer.desc': 'Диаметрі 20-1200 мм',
    'products.gas.title': 'Газ жеткізу үшін полиэтилен құбырлары',
    'products.gas.desc': 'Диаметрі 20-1200 мм',
    'products.coextruded.title': 'Соэкструзиялық қабатты құбырлар',
    'products.coextruded.desc': 'Көпқабатты құбырлар',
    'products.fittings.title': 'Фитингтер мен бұрылыстар',
    'products.fittings.desc': 'Толық ассортимент',
    'products.more': 'Толығырақ',
    'products.fullCatalog': 'Барлық баға-анықтамалар',
    'products.consultation': 'Кеңес алу',
    'products.notFound': 'Қажетті өнімді таба алмадыңыз ба? Кеңес алу үшін бізбен байланысыңыз',
    
    // About Page
    'about.title': '«KazPolimerPlast» ЖШС компаниясы туралы',
    'about.subtitle': 'Компания су жеткізу, канализация, газ жеткізу жүйелеріне арналған полиэтилен құбырларын өндірумен айналысады',
    'about.history': 'Компания тарихы',
    'about.founded': '«KazPolimerPlast» ЖШС 2010 жылдың ақпанында Орал қаласында, Қазақстан Республикасында жоғары сапалы полиэтилен құбырларын өндіру мақсатында құрылды.',
    'about.specialization': 'Компания су жеткізу, канализация, газ жеткізу жүйелеріне арналған полиэтилен құбырларын, сондай-ақ соэкструзиялық қабатты құбырлар мен фитингтерді өндірумен айналысады.',
    'about.production': 'Өндіріс озық технологияларды қолдана отырып, әлемдегі жетекші өндірушілердің заманауи жабдықтарында жүзеге асырылады.',
    'about.capacity': 'Өндірістік қуаттар',
    'about.team': 'Жоғары білікті құрам',
    'about.teamDesc': 'Біздің командамыз полиэтилен құбырларын өндіру саласында көп жылдық тәжірибесі бар жоғары білікті инженерлік-техникалық құрамнан тұрады. Заманауи технологиялар мен өндірістік процестерді үнемі жетілдіру бізге жоғары сапалы өнімдер шығаруға мүмкіндік береді.',
    
    // Header top bar
    'header.phone': 'Телефон',
    'header.address': 'Орал қ., Полевая к. 1Д, тұрғын емес үй-жай 1',
    'header.addressShort': 'Орал қ.',
    'header.workHours': 'Дс-Жм: 9:00-18:00',
    'header.openMenu': 'Мәзірді ашу',
    'header.viewPrice': 'Прайсты көру',
    'nav.certificates': 'Сертификаттар',

    // Quick calculator
    'calc.title': 'Жылдам есептеу',
    'calc.pipeType': 'Құбыр түрі',
    'calc.selectType': 'Түрін таңдаңыз',
    'calc.water': 'Сумен жабдықтау',
    'calc.sewer': 'Канализация',
    'calc.gas': 'Газбен жабдықтау',
    'calc.telecom': 'Телекоммуникация үшін',
    'calc.diameter': 'Диаметр (мм)',
    'calc.sdr': 'SDR',
    'calc.selectSdr': 'SDR таңдаңыз',
    'calc.length': 'Ұзындық (м)',
    'calc.delivery': 'Жеткізу',
    'calc.selectDelivery': 'Түрін таңдаңыз',
    'calc.coils': 'Бухталарда',
    'calc.segments': 'Кесінділерде',
    'calc.city': 'Жеткізу қаласы',
    'calc.selectCity': 'Қаланы таңдаңыз',
    'calc.submit': 'Өтінім жіберу',
    'calc.discount': '1000 м-ден астам тапсырыс берген кезде жеке жеңілдік алыңыз',
    'calc.cityAlert': 'Жеткізу қаласын таңдаңыз',
    'calc.cityTitle': 'Жеткізу қаласын таңдаңыз',
    'calc.citySearch': 'Қала іздеу...',
    'calc.cityNotFound': 'Қала табылмады',
    'calc.popularCities': 'Танымал қалалар:',
    'calc.discountBadge': 'Көтерме тапсырыстарға 25%-ға дейін жеңілдік',
    'calc.submitSuccess': 'Өтінім жіберілді! Жақын арада сізбен байланысамыз.',

    // Calculator section
    'calculator.title': 'Құн калькуляторы',
    'calculator.subtitle': 'Жобаңыздың құнын 30 секундта есептеңіз',
    'calculator.feature1': 'Лезде құнды есептеу',
    'calculator.feature2': 'Өнімнің барлық параметрлерін ескеру',
    'calculator.feature3': 'Өзекті бағалар мен жеңілдіктер',
    'calculator.feature4': 'Есептеуді email-ге жіберу',
    'calculator.quantity': 'Саны',
    'calculator.submit': 'Есептеуді алу',

    // WhatsApp widget
    'whatsapp.greeting': 'Сәлеметсіз бе! Сізге қалай көмектесе аламыз?',
    'whatsapp.message': 'Сәлеметсіз бе! Өніміңіз туралы толығырақ білгім келеді.',
    'whatsapp.formTitle': 'WhatsApp-қа жазу',
    'whatsapp.formName': 'Атыңыз',
    'whatsapp.formPhone': 'Телефон',
    'whatsapp.formMessage': 'Хабарлама',
    'whatsapp.formSubmit': 'WhatsApp-қа жіберу',

    // Common
    'common.loading': 'Жүктелуде...',
    'common.error': 'Қате',
    'common.save': 'Сақтау',
    'common.cancel': 'Болдырмау',
    'common.close': 'Жабу',
    'common.submit': 'Жіберу',
    'common.edit': 'Өңдеу',
    'common.delete': 'Жою',
    'common.confirm': 'Растау',
    'common.yes': 'Иә',
    'common.no': 'Жоқ',
  }
};

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>(() => {
    const savedLanguage = localStorage.getItem('language') as Language;
    return savedLanguage || 'ru';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key: string): string => {
    const translation = translations[language][key as keyof typeof translations[typeof language]];
    if (!translation) {
      console.warn(`Translation missing for key: ${key}`);
      return key;
    }
    return translation;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};